/**
 * Asynchronously loads the component for ResetPasswordPage
 */

import { lazyLoad } from 'utils/loadable';

export const MapTemplatesPage = lazyLoad(
  () => import('./index'),
  module => module.MapTemplatesPage,
);
